import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons/faPen';

import { mapFeaturesToCategory } from './helpers';
import Modal from '../../modal';
import GridColumns from '../../grid-columns';
import ToggleIcon from '../../toggle-icon';
import Button from '../../button';
import FeaturePropType from '../../../utils/prop-types/feature';

export default function AmenitiesEditModal({ buttonClassName, features: featureProps, allFeatures, onSave }) {
  const [groupedFeatures, setGroupedFeatures] = React.useState(mapFeaturesToCategory(allFeatures));
  const [features, setFeatures] = React.useState(featureProps);

  React.useEffect(() => {
    setFeatures(featureProps);
  }, [featureProps]);

  React.useEffect(() => {
    setGroupedFeatures(mapFeaturesToCategory(allFeatures));
  }, [allFeatures]);

  const handleOnAmenityIconClick = (e) => {
    e.preventDefault();
    const amenityId = e.currentTarget.dataset?.value;
    const isChecked = e.currentTarget.getAttribute('aria-checked');
    let selectedFeatures = [];
    if (isChecked === 'true') {
      selectedFeatures = features.filter(f => f.id !== amenityId);
    } else {
      const newFeature = allFeatures.find(af => af.id === amenityId);
      delete newFeature.image_name;
      selectedFeatures = [newFeature].concat(features);
    }

    setFeatures(selectedFeatures);
  };

  const handleOnModalClose = () => {
    setFeatures(featureProps);
  };

  const saveFeature = () => {
    onSave(features);
  };

  return (
    <Modal
      title="EDIT AMENITIES"
      saveButtonText="Save Changes"
      onSave={saveFeature}
      onClose={handleOnModalClose}
      button={(
        <Button
          type="button"
          className={buttonClassName}
          link
        >
          <FontAwesomeIcon icon={faPen} />
        </Button>
      )}
    >
      <GridColumns contents={
          Object.keys(groupedFeatures).map(groupName => ({
            title: `${groupName.charAt(0).toUpperCase()}${groupName.slice(1)} Amenities`,
            body: (
              <div>
                {groupedFeatures[groupName].map(
                  feature => (
                    <ToggleIcon
                      key={feature.id}
                      value={feature.id}
                      name={feature.display_name}
                      imageName={feature.id}
                      canToggle
                      isActive={!!features.find(f => f.id === feature.id)}
                      handleOnClick={handleOnAmenityIconClick}
                      imagePath="/images/stationProfile/v2/"
                    />
                  ),
                )}
              </div>
            ),
          }))}
      />
    </Modal>
  );
}

AmenitiesEditModal.propTypes = {
  buttonClassName: PropTypes.string,
  features: PropTypes.arrayOf(FeaturePropType).isRequired,
  allFeatures: PropTypes.arrayOf(FeaturePropType).isRequired,
  onSave: PropTypes.func.isRequired,
};

AmenitiesEditModal.defaultProps = {
  buttonClassName: '',
};
